module.exports = __webpack_public_path__ + "img/logo_youtube.cf917efd.png";